import { render, staticRenderFns } from "./IntentionSwitch.vue?vue&type=template&id=4ffd2676"
import script from "./IntentionSwitch.vue?vue&type=script&lang=js"
export * from "./IntentionSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports